import { render, staticRenderFns } from "./playerrolessyn.vue?vue&type=template&id=f8ff6354&"
import script from "./playerrolessyn.vue?vue&type=script&lang=js&"
export * from "./playerrolessyn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports